import { render, staticRenderFns } from "./EconomicCalculator.vue?vue&type=template&id=5c14e980&scoped=true&"
import script from "./EconomicCalculator.vue?vue&type=script&lang=ts&"
export * from "./EconomicCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./EconomicCalculator.vue?vue&type=style&index=0&id=5c14e980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c14e980",
  null
  
)

export default component.exports